<template>
  <div class="social-links-container">
    <div class="get_candid container">
      <a
        href="https://www.instagram.com/hp_village/"
        target="_blank"
        class="title"
      >
        GET CANDID
        <span class="title_sub">follow hpvillage on instagram</span>
      </a>

      <div class="instagram-feed grid grid-cols-2 md:grid-cols-4 gap-4">
        <div
          v-for="(item, index) in feed"
          :key="index"
          class="relative group"
          :class="{
            video: useLowerCase(item.media_type) === 'video',
            carousel: useLowerCase(item.media_type) === 'carousel album',
          }"
        >
          <a :href="item.permalink" target="_blank">
            <NuxtImg
              :src="item.images.thumbnail.url"
              :alt="item.caption?.text ? item.caption?.text : 'Instagram image'"
              class="w-full h-auto rounded-md"
            />
            <NuxtImg
              v-if="useLowerCase(item.media_type) === 'carousel album'"
              src="/Images/logos/multi-icon.svg"
              alt
              role="presentation"
              class="multi-caption-icon"
            />
            <NuxtImg
              v-if="useLowerCase(item.media_type) === 'video'"
              src="/Images/logos/play-btn.svg"
              alt
              role="presentation"
              class="video-play-icon"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import { useMainStore } from "~/store/index";
import dayjs from "dayjs";

const store = useMainStore();
const { isMobile, isDesktop } = useMobileChecker();
const { feed, loadSocialFeed } = useSocialFeed();

onMounted(() => {
  loadSocialFeed(8); // Load top 8 Instagram posts
});
</script>

<style lang="scss" scoped>
.social-links-container {
  background: linear-gradient(0deg, $white 0, $white 30%, $black 0, $black);

  a {
    text-decoration: none;
    color: $white !important;
  }

  .get_candid {
    padding: 100px 0 50px;

    .title {
      font-family: $font_didot_italic;
      font-style: italic;
      font-weight: default;
      text-transform: uppercase;
      letter-spacing: -5px;
      font-size: 72px;
      line-height: 72px;
      color: $white;
      margin: 0 0 -15px 0;
      text-align: left;

      .title_sub {
        font-family: $font_poppin;
        font-size: 12px;
        font-weight: 300;
        text-transform: uppercase;
        line-height: 12px;
        letter-spacing: 2px;
        font-style: normal;
        position: absolute;
        margin: 33px 0 0 23px;
      }
    }

    .instagram-feed {
      display: grid;
      grid-template-columns: repeat(8, 1fr);
      gap: 0; 
      width: 100%;
      
      > div {
        contain: content;
        aspect-ratio: 1 / 1;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          max-height: 161px;
          object-fit: cover;
          object-position: center;
          display: block;
        }

        .multi-caption-icon {
          position: absolute;
          top: 8px;
          right: 8px;
          width: 20px;
          height: 20px;
          z-index: 10;
          filter: invert(1);
          pointer-events: none;
        }

        .video-play-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 20px; // slightly larger for visibility
          height: 22px;
          z-index: 10;
          pointer-events: none;
        }
      }
    }
  }
}
</style>